const CLASS_ATTR = /class\s*=\s*"([^"]*)"|class\s*=\s*'([^']*)'/g;

export function scrapeClasses(htmls: string[]): Set<string> {
  const out = new Set<string>();
  for (const html of htmls) {
    let m: RegExpExecArray | null;
    CLASS_ATTR.lastIndex = 0;
    while ((m = CLASS_ATTR.exec(html))) {
      const list = (m[1] ?? m[2] ?? '').split(/\s+/);
      for (const c of list) if (c) out.add(c);
    }
  }
  return out;
}

// String/template literal contents — where TSX (className="…") and the shadcn
// `@/ui` component sources (cva variant strings) keep their class lists. JSX
// uses className (not class=), and the cva vocabulary lives in the library
// source, so neither is reachable by scrapeClasses above.
const STRING_LIT = /(['"`])((?:\\.|(?!\1)[\s\S])*?)\1/g;
// A token that plausibly is a Tailwind class candidate: lowercase start (real
// utilities are lowercase) but uppercase allowed inside arbitrary values like
// text-[#FFF]. Over-collection is harmless — the compiler only emits utilities
// for candidates it recognizes.
const CLASS_TOKEN = /^-?[a-z][a-zA-Z0-9:_/\[\]().,#%!.-]*$/;

/**
 * Collect class-name candidates from raw TS/TSX source (tsx frame sources +
 * the `@/ui` component library). Pulls every string/template literal, splits on
 * whitespace, and keeps tailwind-shaped tokens. Broad by design.
 */
export function scrapeClassTokens(sources: string[]): Set<string> {
  const out = new Set<string>();
  for (const src of sources) {
    if (!src) continue;
    let m: RegExpExecArray | null;
    STRING_LIT.lastIndex = 0;
    while ((m = STRING_LIT.exec(src))) {
      const body = m[2] ?? '';
      if (!body) continue;
      for (const tok of body.split(/\s+/)) {
        if (tok && CLASS_TOKEN.test(tok)) out.add(tok);
      }
    }
  }
  return out;
}
